import React from "react";
import { Check, X } from "lucide-react";

const WE = [
  "We own the trucks that move your vehicle",
  "Same driver from pickup to delivery",
  "Direct contact — no call-center runaround",
  "Fixed quote. No broker markup. No surprises.",
  "Fully insured Canadian carrier",
  "Inspection photos at every hand-off",
];

const THEY = [
  "Post your job on load boards",
  "Unknown driver shows up — sometimes",
  "You chase a dispatcher you've never met",
  "Price changes after you're locked in",
  "Coverage depends on who takes the load",
  "Damage claims get bounced between parties",
];

export default function WhyUs() {
  return (
    <section id="why-us" className="bg-[#EAEAE5] border-b-2 border-[#122A1E]" data-testid="why-us-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-4">
            <div className="font-mono-accent text-[11px] uppercase text-[#4A5550] mb-3">
              ◆ 002 · Why Us
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter leading-none text-[#0A0E0C] text-4xl md:text-5xl">
              Direct Carrier.
              <br />
              <span className="text-[#FF5A00]">Full Stop.</span>
            </h2>
            <p className="mt-5 text-[#4A5550] text-base leading-relaxed">
              Most "transport companies" are brokers. They list your job online
              and hope someone shows up. We're the ones who actually show up.
            </p>
          </div>

          <div className="lg:col-span-8 grid md:grid-cols-2 gap-5">
            <div className="border-2 border-[#122A1E] bg-[#F4F4F1] p-7 hard-shadow-sm" data-testid="us-column">
              <div className="flex items-center gap-3 mb-5 pb-4 border-b-2 border-[#122A1E]">
                <span className="w-8 h-8 bg-[#FF5A00] text-white flex items-center justify-center font-display font-black">
                  ✓
                </span>
                <div>
                  <div className="font-mono-accent text-[10px] uppercase text-[#4A5550]">M&R Hauling</div>
                  <div className="font-display font-black uppercase text-lg text-[#0A0E0C]">The Direct Carrier</div>
                </div>
              </div>
              <ul className="space-y-3">
                {WE.map((item) => (
                  <li key={item} className="flex gap-3 text-[#0A0E0C]">
                    <Check size={18} className="mt-1 flex-none text-[#FF5A00]" />
                    <span className="text-sm leading-snug font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="border-2 border-[#D2CEBD] bg-[#F4F4F1]/60 p-7" data-testid="them-column">
              <div className="flex items-center gap-3 mb-5 pb-4 border-b-2 border-[#D2CEBD]">
                <span className="w-8 h-8 bg-[#D2CEBD] text-[#4A5550] flex items-center justify-center font-display font-black">
                  ✕
                </span>
                <div>
                  <div className="font-mono-accent text-[10px] uppercase text-[#4A5550]">The Broker Model</div>
                  <div className="font-display font-black uppercase text-lg text-[#4A5550]">The Middleman</div>
                </div>
              </div>
              <ul className="space-y-3">
                {THEY.map((item) => (
                  <li key={item} className="flex gap-3 text-[#4A5550]">
                    <X size={18} className="mt-1 flex-none text-[#4A5550]" />
                    <span className="text-sm leading-snug">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
